import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const FloatingScrollToTop = ({ 
    showAfter = 400,
    bottom = "2rem",
    right = "2rem"
}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > showAfter) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, [showAfter]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    if (!isVisible) return null;

    return (
        <button
            onClick={scrollToTop}
            className="
                fixed z-50 group
                bg-slate-900 hover:bg-slate-800 
                text-white rounded-full p-4
                shadow-2xl hover:shadow-2xl
                drop-shadow-lg hover:drop-shadow-xl
                transition-all duration-300 ease-in-out
                hover:scale-110
                focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2
                animate-fadeIn
            "
            style={{ 
                bottom: bottom, 
                right: right,
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.1)'
            }}
            aria-label="Scroll to top"
            title="Back to top"
        >
            <ArrowUp className="w-6 h-6 transition-transform duration-300 group-hover:-translate-y-1" />
        </button>
    );
};

export default FloatingScrollToTop;